
import { Vue, Component, Prop } from 'vue-property-decorator'
import StudentHomeApi from '@/apis/ktpStudentHome/index';
import moment from 'moment';
import { TrackLogType } from '@/interfaces/paycoursetracklog';
  
//正在学习的课程
@Component({
  name: 'grownPlanLists',
  components: {

  },
  props: {

  }
})
export default class grownPlanLists extends Vue {
  @Prop(({ default: '适合你的成长计划' }))  bigTitle!: string;

  moment=moment;
  private currentTime:number = Date.now()/1000;
  private growthPlan: Array<any> = [];
  
  created() {
      this.getGrowthPlanList();
  }

  mounted(){
    this.currentTime = Date.now()/1000;
  }

  getGrowthPlanList() {
    StudentHomeApi.getGrowthPlanList({ source: '1' }).then((res: any) => {
      this.growthPlan = res
    });
  }

  //前往成长计划
  gotoPlan(item:any){
    StudentHomeApi.trackLog({
      type: TrackLogType.GROWING_PLAN,
      event_id: item.id,
      residence_time:(Date.now()/1000 - this.currentTime),
    });
    this.$router.push({ path: '/growingProcessInfo', query: { tagId: item.tag_id, planId: item.id } })
  }

}
